import { render, staticRenderFns } from "./MoreDropdown.vue?vue&type=template&id=00dee140&"
import script from "./MoreDropdown.vue?vue&type=script&lang=js&"
export * from "./MoreDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports